import { render, staticRenderFns } from "./LoadingSubmitSpot.vue?vue&type=template&id=405a9901"
import script from "./LoadingSubmitSpot.vue?vue&type=script&lang=js"
export * from "./LoadingSubmitSpot.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports